import { useEffect } from 'react';

interface OutOfCreditsPopupProps {
  type: 'credits' | 'projects';
  onClose: () => void;
}

export default function OutOfCreditsPopup({ type, onClose }: OutOfCreditsPopupProps) {
  const title = type === 'credits' ? 'Out of credits' : 'Project limit reached';
  const message =
    type === 'credits'
      ? 'You have run out of credits. Email team@playentire.com and we will usually top you up the same day.'
      : 'You have reached the maximum number of projects allowed. Delete an existing project to create a new one.';

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="eyebrow" style={{ color: 'var(--accent)', marginBottom: 8 }}>
          {type === 'credits' ? 'Beta credits' : 'Beta cap'}
        </div>
        <h3 className="display tight" style={{ fontSize: 24, margin: '0 0 10px' }}>
          {title}
        </h3>
        <p className="muted-2" style={{ fontSize: 13.5, lineHeight: 1.55, margin: '0 0 22px' }}>
          {message}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button type="button" className="btn primary" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
